































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
  @Prop() tableName!: string;

  @Prop() primaryid!: number;

  dispatchType = 'operationlogs/history';

  columns: any[] = [
    { title: '序号', dataIndex: 'id' },
    { title: '操作人头像', scopedSlots: { customRender: 'avatar' } },
    { title: '操作人用户名', scopedSlots: { customRender: 'username' } },
    { title: '变更日期', dataIndex: 'created_time' },
    { title: '变更项目', dataIndex: 'content' },
    { title: '变更前', scopedSlots: { customRender: 'oldval' } },
    { title: '变更后', scopedSlots: { customRender: 'newval' } },
  ];

  mounted() {
    this.loadData(
      {
        table_name: this.tableName,
        primaryid: this.primaryid,
      },
      false,
    );
  }
}
